import SectionHeading from "@/pages/home/components/SectionHeading";
import { topics } from "@/mocks/content";

export default function TopicsSection() {
  return (
    <section id="topics" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading
          eyebrow="两性话题"
          title="没有标准答案，只有更好的理解"
          desc="有些问题争论了很多年，依然各说各话。比起替你站队，我们更想把这些话题的两面都摊开，让你看清后自己做选择。"
        />

        <div className="mt-10 space-y-5">
          {topics.map((topic) => (
            <article key={topic.q} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
              <h3 className="flex items-start gap-3 font-heading text-lg font-semibold text-foreground-950">
                <i className="ri-chat-1-line mt-1 text-primary-500"></i>
                {topic.q}
              </h3>

              <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="rounded-md border border-primary-200/70 bg-primary-50 p-4">
                  <span className="font-label text-xs font-medium text-primary-700">一种看法</span>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-800">{topic.a}</p>
                </div>
                <div className="rounded-md border border-secondary-200/70 bg-secondary-50 p-4">
                  <span className="font-label text-xs font-medium text-secondary-700">另一种看法</span>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-800">{topic.b}</p>
                </div>
              </div>

              <div className="mt-4 flex items-start gap-3 rounded-md bg-accent-100/70 p-4">
                <i className="ri-compass-3-line mt-0.5 text-accent-700"></i>
                <p className="text-sm leading-relaxed text-foreground-800">{topic.note}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}